import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface UnlinkedResultPayloadDialogData {
  title: string;
  rawPayload: string;
}

/** Read-only view of the raw vendor payload. Fetched only when a human opens one. */
@Component({
  selector: 'app-unlinked-result-payload-dialog',
  templateUrl: './unlinked-result-payload-dialog.component.html',
  styleUrls: ['./unlinked-result-payload-dialog.component.scss']
})
export class UnlinkedResultPayloadDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<UnlinkedResultPayloadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UnlinkedResultPayloadDialogData
  ) { }

  close(): void {
    this.dialogRef.close();
  }
}
